export default "__VITE_ASSET__vrC8jGbl__"